export default __webpack_public_path__ + "static/media/1786.6a85e067.png";